export default __webpack_public_path__ + "static/media/dispatched_default_noeld.1f138861.svg";